import React, { useState, useEffect } from 'react';
// import Vimeo from '@u-wave/react-vimeo';
import { motion, AnimatePresence } from 'framer-motion';

import BigButton from '../../UI/BigButton/BigButton';
import classes from './DiscoverVideos.module.scss';
import VideoPlayer from '../../UI/VideoPlayer/VideoPlayer';

const contents = [
  {
    video: '458819790',
    texts: {
      about: 'Featuring the stunning Simran Pareek, in the golden hours of Chennai\'s seashore, Waves hitting on rocks. Simran\'s on @SheinOfficial bikini with a custom headpiece designed by Harshitha Pragathi. Both styles were shot and directed within 2 hours, including the styling and makeup time.',
      casts: [
        'By: Akash Sekar',
		'Model: Simran Pareek',
        'MUAH: Anupama Krishnamachari',
        'Stylist: Samiha Iyer',
		'Assistant: Harshitha Pragathi'
      ]
    }
  },
  {
    video: '458819754',
    texts: {
      about: 'Magnificent location, Mahabalipuram is best known for the UNESCO World Heritage Site. Shot with the rise of the sun. Beautiful Jane Thompson with Indian traditional lehenga, custom made by a designer based in Chennai. The team Hiked up to the tallest mountains in Mahabalipuram for a fantastic shot like this. Check out the photoshoot album for more! ',
      casts: [  
        'By: Akash Sekar',
        'Model: Jane Thompson',
        'Stylist: Pavitra Shankar Prasad',
		'Location asst: MD Khan',
		'Costume: Soul Spectrum',
		'Jewellery: Nayaki'

      ]
    }
  },
  {
    video: '458819750',
    texts: {
      about: 'Vinu Sha\'s in the beautiful tropical garden. More than 50km away from Chennai. In the very early morning wearing a private, designed black saree with sliver coated pieces of jewellery. With the blooming flowers in hand just and the slow and steady movements in the shots made this shoot a dreamlike sequence. ',
      casts: [
        'By: Akash Sekar',
        'Model: Vinu Sha',
        'Assistant: Subash Chandra'
      ]
    }
  },
  {
    video: '458819638',
    texts: {
      about: 'The Gorgeous looking Sristika @ Chennai\'s railway station with the privately designed graffiti walls by artists around Chennai. Giving a vibe of street and style and made it more with Maybelline and H&M. A Series of Photoshoot with two different style types shot and directed within an hour. ',
      casts: [
        'By: Akash Sekar',
        'Model: Sristika',
        'Assistant: Subash Chandra'
      ]
    }
  }
];
const videos = contents.map(content => content.video);
const textContents = contents.map(content => content.texts);

const getVideoWidth = ()=> window.innerWidth > 775 
  ? Math.min(window.innerWidth * 0.6, window.innerHeight * 0.85) 
  : Math.min(window.innerWidth * 0.7, window.innerHeight * 0.6);
const imageMargin = window.innerWidth * 0.06;

const DiscoverVideos = ({ onBack, className, style }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [videoWidth, setVideoWidth] = useState(getVideoWidth());
  const [videoShow, setVideoShow] = useState(true);
  const imagesTransX = - ((videoWidth + imageMargin) * activeIndex);

  useEffect(()=> {
    const resizeHandler = ()=> {
      setVideoWidth(getVideoWidth());
    };
    window.addEventListener('resize', resizeHandler);

    return ()=> window.removeEventListener('resize', resizeHandler);
  }, []);

  useEffect(()=> {
    setVideoShow(false);
    const timeout = setTimeout(()=> setVideoShow(true), 100);
    return()=> clearTimeout(timeout);
  }, [videoWidth]);

  const changeToNext = ()=> activeIndex < contents.length-1 ? setActiveIndex(prevIndex => prevIndex+1) : 0;
  const changeToPrev = ()=> activeIndex > 0 ? setActiveIndex(prevIndex => prevIndex-1) : 0;

  const rootClass = [classes.DiscoverVideos, 'scrollable'];
  if (className) rootClass.push(className);

  return (
    <div className={rootClass.join(' ')} style={style ? style:{}}>

      {/* <div className={classes.BackButton} onClick={onBack}>
        <div className={classes.Arrow}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.16 16.36"
            style={{ transform: `rotate3d(0, 1, 0, -180deg)` }}
          >
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <polygon points="1.36 16.36 0 14.89 7.22 8.18 0 1.46 1.36 0 10.16 8.18 1.36 16.36"/>
              </g>
            </g>
          </svg>
        </div>

        <p className={classes.Text}>Go back to main page</p>
      </div> */}
      
      <div className={classes.Contents}>

        <div className={classes.Top}>
          <div className={classes.VideoChanger}>
            <div className={classes.Body}>
              <div className={classes.Videos} style={{transform: `translateX(${imagesTransX}px)`}}>
                {videos.map((video, i) => {
                  const classNames = [classes.VideoContainer];
                  if (i < activeIndex) classNames.push(classes.Hide);
                  else if (i === activeIndex) classNames.push(classes.Active);

                  return (
                    <div className={classNames.join(' ')} key={i}
                      style={{ width: videoWidth, marginRight: imageMargin }}>
                        {videoShow && <VideoPlayer video={video} width={videoWidth} />}
                      </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        
        <div className={classes.Bottom}>
          <div className={classes.Left}>

            <div className={classes.Left}>
              <h4 className={classes.Title}>About this project</h4>

              <div className={classes.Details}>
                <AnimatePresence key={activeIndex}>
                  <motion.p className={classes.Text}
                    key={activeIndex}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.8 }}
                  >
                    {textContents[activeIndex].about}
                  </motion.p>
                </AnimatePresence>
                {false && textContents.map((texts, i) => {
                  const classNames = [classes.Text];
                  if (i === 0) classNames.push(classes.Static);
                  if (i === activeIndex) classNames.push(classes.Active);

                  return (
                    <p className={classNames.join(' ')} key={i}>{texts.about}</p>
                  );
                })}
              </div>
            </div>
            <div className={classes.Right}>
              <h4 className={classes.Title}>Cast</h4>

              <div className={classes.Casts}>
                <AnimatePresence key={activeIndex}>
                  {textContents[activeIndex].casts.map((cast, i) => (
                    <motion.p className={classes.Text}
                      key={activeIndex + '-' + i}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.8, delay: 0.05 * i }}
                    >
                      {cast}
                    </motion.p>
                  ))}
                </AnimatePresence>
                {false && textContents.map((texts, i) => {
                  const classNames = [classes.Cast];
                  if (i === 0) classNames.push(classes.Static);
                  if (i === activeIndex) classNames.push(classes.Active);

                  return (
                    <div className={classNames.join(' ')} key={i}>
                      {texts.casts.map((cast, j) => (
                        <p className={classes.Text} key={i+'-'+j}
                          style={{ transitionDelay: `${100 * j}ms` }}
                        >{cast}</p>
                      ))}
                    </div>
                  );
                })}
              </div>
            </div>
            
          </div>
          <div className={classes.Right}>
            <div className={classes.ChangeButtons}>
              <div className={[classes.Button, classes.NextButton].join(' ')}>
                <BigButton disabled={activeIndex >= contents.length-1} 
                  className={classes.Btn}
                  clicked={changeToNext}>Next</BigButton>
              </div>
              <div className={[classes.Button, classes.PrevButton].join(' ')}>
                <BigButton disabled={activeIndex <= 0} 
                  className={classes.Btn}
                  clicked={changeToPrev}>Previous</BigButton>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  );
}

export default DiscoverVideos;